// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.copyright[data-v-ddc69f4c] {\n  text-align: center;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n.friend-links[data-v-ddc69f4c] {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n.friend-link[data-v-ddc69f4c] {\n  margin: 0 0.5rem;\n  color: #fff;\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
